var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33368 26.667V11.967C9.33368 11.2337 9.60034 10.6115 10.1337 10.1003C10.667 9.58923 11.3003 9.33368 12.0337 9.33368H26.667C27.4003 9.33368 28.0281 9.59479 28.5503 10.117C29.0726 10.6392 29.3337 11.267 29.3337 12.0003V22.667L22.667 29.3337H12.0003C11.267 29.3337 10.6392 29.0726 10.117 28.5503C9.59479 28.0281 9.33368 27.4003 9.33368 26.667ZM2.70034 8.33368C2.56701 7.60034 2.71145 6.93923 3.13368 6.35034C3.5559 5.76146 4.13368 5.40034 4.86701 5.26701L19.3337 2.70034C20.067 2.56701 20.7281 2.71145 21.317 3.13368C21.9059 3.5559 22.267 4.13368 22.4003 4.86701L22.7337 6.66701H20.0003L19.767 5.33368L5.33368 7.90034L6.66701 15.4337V24.7337C6.31146 24.5337 6.0059 24.267 5.75034 23.9337C5.49479 23.6003 5.33368 23.2226 5.26701 22.8003L2.70034 8.33368ZM12.0003 12.0003V26.667H21.3337V21.3337H26.667V12.0003H12.0003Z",
    fill: "#006AA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.2495ce65850350985100fb75562a337b.svg";
export { ForwardRef as ReactComponent };